/**
 * 价格格式化工具函数
 */

import { formatNumberWithZeroCount } from "utils";
import type { PriceFormatResult } from "./types";

/**
 * 格式化价格显示为PriceDisplay所需的格式
 * @param price 价格值
 * @returns 格式化后的价格数据对象
 */
export const formatPriceForDisplay = (
  price: string | null | undefined,
): PriceFormatResult => {
  // 检查输入值有效性
  if (
    price === null ||
    price === undefined ||
    price === "" ||
    isNaN(Number(price))
  ) {
    return {
      integerPart: "",
      leftDigits: null,
      zeroCount: 0,
      isSuccess: false,
    };
  }

  const numPrice = Number(price);

  // 零值处理
  if (numPrice === 0) {
    return {
      integerPart: "0",
      leftDigits: "0",
      zeroCount: 0,
      isSuccess: true,
    };
  }

  // 转换为字符串用于格式化
  // const numStr = numPrice.toLocaleString("fullwide", {
  //   useGrouping: false,
  //   maximumFractionDigits: 20,
  // });

  // 使用formatNumberWithZeroCount格式化
  const priceData = formatNumberWithZeroCount({
    numStr: price,
    decimals: 6,
    minZeroCount: 6,
  });

  // 计算leftDigits（根据PriceHeader.tsx的逻辑）
  let leftDigits: string | null = null;
  if (priceData?.isSuccess) {
    const integerPart = Number(priceData.integerPart);
    if (integerPart > 0 && priceData?.leftDigits?.length > 2) {
      leftDigits = priceData.leftDigits?.substring(0, 2);
    } else if (integerPart === 0 && priceData?.leftDigits?.length > 6) {
      leftDigits =
        Number(priceData.leftDigits?.substring(0, 6) || 0) !== 0
          ? priceData.leftDigits?.substring(0, 6)
          : null;
    } else {
      leftDigits = priceData?.leftDigits;
    }
  } else {
    leftDigits = priceData?.leftDigits;
  }

  return {
    integerPart: priceData?.integerPart || "",
    leftDigits,
    zeroCount: priceData?.zeroCount,
    isSuccess: priceData?.isSuccess || false,
  };
};
